module.exports = __webpack_public_path__ + "img/kutipsampah.721f6765.jpg";